import type { ICountDownTimerProps } from './CountDownTimer';

export async function MountCountDownTimer(props: ICountDownTimerProps, el: Element) {
	const module = await import('./CountDownTimer');
	module.MountCountDownTimer(props, el);
}

(window as any).MountCountDownTimer = MountCountDownTimer;
